(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trabalhe-conosco-v10"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  function initAgroverdeCareers(root = document) {
    root.querySelectorAll(".agv-careers").forEach((section) => {
      if (!section.dataset.careersReady) {
        section.dataset.careersReady = "true";
        new AgroverdeCareers(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAgroverdeCareers());
  } else {
    initAgroverdeCareers();
  }

  document.addEventListener("shopify:section:load", (event) => initAgroverdeCareers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v11"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  function initAgroverdeCareers(root = document) {
    root.querySelectorAll(".agv-careers").forEach((section) => {
      if (!section.dataset.careersReady) {
        section.dataset.careersReady = "true";
        new AgroverdeCareers(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAgroverdeCareers());
  } else {
    initAgroverdeCareers();
  }

  document.addEventListener("shopify:section:load", (event) => initAgroverdeCareers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v2"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  document.querySelectorAll(".agv-careers").forEach((section) => {
    if (!section.dataset.careersReady) {
      section.dataset.careersReady = "true";
      new AgroverdeCareers(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v3"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  document.querySelectorAll(".agv-careers").forEach((section) => {
    if (!section.dataset.careersReady) {
      section.dataset.careersReady = "true";
      new AgroverdeCareers(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v4"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  document.querySelectorAll(".agv-careers").forEach((section) => {
    if (!section.dataset.careersReady) {
      section.dataset.careersReady = "true";
      new AgroverdeCareers(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v5"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  document.querySelectorAll(".agv-careers").forEach((section) => {
    if (!section.dataset.careersReady) {
      section.dataset.careersReady = "true";
      new AgroverdeCareers(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v6"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  document.querySelectorAll(".agv-careers").forEach((section) => {
    if (!section.dataset.careersReady) {
      section.dataset.careersReady = "true";
      new AgroverdeCareers(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v7"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  function initAgroverdeCareers(root = document) {
    root.querySelectorAll(".agv-careers").forEach((section) => {
      if (!section.dataset.careersReady) {
        section.dataset.careersReady = "true";
        new AgroverdeCareers(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAgroverdeCareers());
  } else {
    initAgroverdeCareers();
  }

  document.addEventListener("shopify:section:load", (event) => initAgroverdeCareers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v8"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  function initAgroverdeCareers(root = document) {
    root.querySelectorAll(".agv-careers").forEach((section) => {
      if (!section.dataset.careersReady) {
        section.dataset.careersReady = "true";
        new AgroverdeCareers(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAgroverdeCareers());
  } else {
    initAgroverdeCareers();
  }

  document.addEventListener("shopify:section:load", (event) => initAgroverdeCareers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco-v9"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  function initAgroverdeCareers(root = document) {
    root.querySelectorAll(".agv-careers").forEach((section) => {
      if (!section.dataset.careersReady) {
        section.dataset.careersReady = "true";
        new AgroverdeCareers(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAgroverdeCareers());
  } else {
    initAgroverdeCareers();
  }

  document.addEventListener("shopify:section:load", (event) => initAgroverdeCareers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trabalhe-conosco"] && !Shopify.designMode) return;
  try {
    
  class AgroverdeCareers {
    constructor(section) {
      this.section = section;
      this.endpoint = section.dataset.endpoint;
      this.dialog = section.querySelector("[data-application-dialog]");
      this.form = section.querySelector("[data-application-form]");
      this.status = section.querySelector("[data-form-status]");
      this.emptyState = section.querySelector("[data-empty-state]");
      this.cards = Array.from(section.querySelectorAll("[data-vacancy-card]"));
      this.filters = Array.from(section.querySelectorAll("[data-location-filter]"));
      this.bindEvents();
      this.setSourceUrl();
    }

    bindEvents() {
      this.filters.forEach((filter) => {
        filter.addEventListener("click", () => this.filterVacancies(filter.dataset.locationFilter));
      });

      this.section.querySelectorAll("[data-apply-button]").forEach((button) => {
        button.addEventListener("click", () => this.openApplication(button));
      });

      this.section.querySelector("[data-dialog-close]").addEventListener("click", () => this.dialog.close());
      this.form.addEventListener("submit", (event) => this.submitApplication(event));
    }

    filterVacancies(location) {
      let visibleCount = 0;

      this.filters.forEach((filter) => {
        filter.classList.toggle("is-active", filter.dataset.locationFilter === location);
      });

      this.cards.forEach((card) => {
        const shouldShow = location === "all" || card.dataset.location === location;
        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      this.emptyState.hidden = visibleCount > 0;
    }

    openApplication(button) {
      const locationField = this.form.querySelector("[data-form-location]");
      const jobTitleField = this.form.querySelector("[data-form-job-title]");
      const selectedJob = this.section.querySelector("[data-selected-job]");

      locationField.value = button.dataset.location;
      jobTitleField.value = button.dataset.jobTitle;
      selectedJob.textContent = `${button.dataset.jobTitle} - ${button.dataset.locationLabel}`;
      this.status.textContent = "";

      if (typeof this.dialog.showModal === "function") {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute("open", "");
      }
    }

    setSourceUrl() {
      const sourceField = this.form.querySelector("[data-form-source-url]");

      if (sourceField) {
        sourceField.value = window.location.href;
      }
    }

    async submitApplication(event) {
      event.preventDefault();

      if (!this.endpoint) {
        this.status.textContent = "Configure a URL do endpoint de candidatura no editor do tema.";
        return;
      }

      const submitButton = this.form.querySelector("[type='submit']");
      submitButton.disabled = true;
      this.status.textContent = "Enviando candidatura...";

      try {
        const response = await fetch(this.endpoint, {
          method: "POST",
          body: new FormData(this.form)
        });
        const result = await response.json();

        if (!response.ok || !result.ok) {
          throw new Error((result.errors || []).join(" "));
        }

        this.form.reset();
        this.setSourceUrl();
        this.status.textContent = "Candidatura enviada. O RH da Agroverde recebeu seu currículo.";
      } catch (error) {
        this.status.textContent = error.message || "Não foi possível enviar sua candidatura agora.";
      } finally {
        submitButton.disabled = false;
      }
    }
  }

  document.querySelectorAll(".agv-careers").forEach((section) => {
    if (!section.dataset.careersReady) {
      section.dataset.careersReady = "true";
      new AgroverdeCareers(section);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
